import React, { Fragment, useEffect, useState } from 'react';
import { Modal, Row, Col } from 'antd';
import  fleetLogo from "../assets/images/FleetEnableLogo.svg";
import closeIcon from "../assets/images/IconButtonClose.svg";
import cancelIcon from "../assets/images/cancel.svg";
import _ from 'lodash';
import { FleetLogo } from './common/CustomIcon';
import { learnMore } from './helpers/common';

const BottomBannerModal = ({ userContext, shouldShowBanner = false, setShouldShowBanner = () => {} }) => {
  const [showBanner, setShowBanner] = useState(false);

  useEffect(() => {
    if(shouldShowBanner){
      setShowBanner(true) 
    }
  }, [shouldShowBanner]);


  const handleBannerClose = () => {
    const { updateScreenConfig } = userContext;
    setShowBanner(false);
    setShouldShowBanner();
    if(!shouldShowBanner){
      updateScreenConfig('order_listing', false, 'show_v2_jun9th_hint');
    }
  };


  const tryIt = () => {
    window.open('https://platform.fleetenable.com/login', '_blank');
  };

  useEffect(() => {
    const { currentUser } = userContext;
    const showMessage = _.get(
      currentUser,
      'screen_config.order_listing.show_v2_jun9th_hint',
      true
    );
    if (showMessage === true || showMessage === "true") {
        setShowBanner(true);
    }
    else {
        setShowBanner(false);
    }
  }, [])

  const renderBanner = () => {
      return (
        <Modal
          visible={showBanner}
          closable={false}
          footer={null}
          style={{
            position: 'fixed',
            left: 40,
            top: 'calc(100vh - 200px - 40px)',
            margin: 0,
            //boxShadow: '0 4px 12px rgba(0, 0, 0, 0.2)',
          }}
          bodyStyle={{
            padding: "24px",
          }}
          mask={false}
          wrapClassName="custom-modal-position"
          className="top-banner modalClass"
          width={545}
        >
          <div>
            <Row>
              <Col style={{ display: "flex", justifyContent: "space-between" }}>
               <span className="titleModal">New UI is Here! Try the New Look</span>
               <img src={cancelIcon} alt="" style={{ width: "30px", height: "30px", cursor: "pointer" }} onClick={handleBannerClose}/>
              </Col>
            </Row>
            <Row
              style={{
                fontWeight: 500,
                padding: "16px 0px",
                display: "flex",
                alignItems: "center",
              }}
            >
              <Col flex="none">
                {/* <img
                  style={{ height: "32px", width: "32px" }}
                  src={fleetLogo}
                  alt=""
                /> */}
                <FleetLogo width={32} height={32} />
              </Col>
              <Col style={{ paddingLeft: "25px" }} className="top-banner-message">
                The New UI enhancements will be officially launched on <b>June 9</b>, but you don't have to wait! Experience these amazing changes for yourself today.
              </Col>
            </Row>
            <Row>
              <Col className="top-banner-actions" style={{ display: "flex", justifyContent: "center",gap: "16px" }}>
                <button className="learn-more-button"  onClick={() => learnMore('academy', userContext?.currentUser?.id || "") }>
                Learn More
              </button>
                <button  className="tryit-now-button" onClick={tryIt}>
                Try It Out Now
              </button>
              </Col>
            </Row>
          </div>
        </Modal>
      );
    };

  return (
   <Fragment>{showBanner && renderBanner()}</Fragment>
  );
};

export default BottomBannerModal;
